import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable, map, of} from 'rxjs';

export type DynamicAutocompleteResponse = {
    tableName: string;
    items: DynamicAutocompleteItem[];
};

export type DynamicAutocompleteItem = {
    id?: number;
    value: string;
    originalValue?: string;
};

type DynamicAutocompleteParams = {
    tableName: string;
    columnName: string;
    userInput: string;
    maxResults: number;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicAutocompleteService {
  private readonly baseUrl = 'dbov2/autocomplete/search';
  private readonly http = inject(HttpClient);
  
  private getFormattedColumnName(columnName: string): string {
    return columnName.charAt(0).toUpperCase() + columnName.slice(1);
  }
  
  private getFormattedTableName(tableName: string): string {
    return tableName.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }
  getOptions(params:DynamicAutocompleteParams): Observable<DynamicAutocompleteResponse>  {
    const userInput = params.userInput ? params.userInput.trim() : '';
    
    const formattedParams = {
      ...params,
      tableName: this.getFormattedTableName(params.tableName),
      columnName: this.getFormattedColumnName(params.columnName),
      userInput: userInput,
      maxResults: Math.max(params.maxResults, 25)
    };
    const isClientProfileName = params.tableName.toLowerCase() === 'client' && 
                               params.columnName.toLowerCase() === 'profilename';
                               
    if (isClientProfileName) {
      formattedParams.columnName = 'ProfileName';
    }
        
    
    return this.http.get<DynamicAutocompleteResponse>(`${this.baseUrl}`, { params: {...formattedParams} })
    .pipe(
      map((response: DynamicAutocompleteResponse) => {
        const uniqueItems: DynamicAutocompleteItem[] = [];
        const valueSet = new Set<string>();
        
        response.items.forEach(item => {
          if (item.value && !valueSet.has(item.value.toLowerCase())) {
            valueSet.add(item.value.toLowerCase());
            
            if (isClientProfileName) {
              item.originalValue = item.value;
            }
            
            uniqueItems.push(item);
          }
        });

        return {
          ...response,
          items: uniqueItems
        };
      }),
      catchError((error:HttpErrorResponse)=>{
        console.error('Autocomplete error:', error);
        return of({ tableName: params.tableName, items: [] });
      }));
  }
}